import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import { Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

export function SettingsActionButton({
  children,
  label,
  disabled,
  onClick,
  testId,
  ariaBusy = false,
  tooltip,
}: {
  children: ReactNode;
  label: string;
  disabled?: boolean;
  onClick: () => void;
  testId?: string;
  ariaBusy?: boolean;
  tooltip?: string;
}) {
  const button = (
    <Button
      type="button"
      variant="transparent"
      data-testid={testId}
      disabled={disabled || ariaBusy}
      onClick={onClick}
      aria-label={label}
      aria-busy={ariaBusy}
      title={tooltip ?? label}
      className="text-steel-400 hover:text-steel-500 size-6 shrink-0 p-1"
    >
      {ariaBusy ? <Loader2 aria-hidden="true" className="size-4 animate-spin" /> : children}
    </Button>
  );
  if (!tooltip) return button;
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>{button}</TooltipTrigger>
        <TooltipContent side="top">
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
